import React, { useContext, useState } from "react";
import Navbar from "../components/Navbar";
import { useNavigate, Link } from "react-router-dom";
import data from "../language.json";
import languageContext from "../context/language/languageContext";
import axios from "axios";

const Login = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const { lang, phone, setPhone } = useContext(languageContext);

  // Handle Login
  const handleLogin = async (e) => {
    e.preventDefault();
    if (phone.length !== 10) {
      alert("Please enter a valid 10-digit number");
      return;
    }

    const headerList = {
      Accept: "*/*",
      "Content-Type": "application/json",
    };

    try {
      setLoader(true);
      const response = await axios.post(
        "https://www.careplus.gopillz.com/nurse_send_otp_al_chatbot",
        JSON.stringify({ phone }),
        { headers: headerList }
      );
      console.log(response.data.msg);
      if (response.status === 202) {
        setResponseMessage(response.data.message || "OTP sent successfully.");
        // Navigate only after a successful response
        navigate("/otp", { state: { from: "signup" } });
      } else if (response.status === 401) {
        setResponseMessage(response.data.msg || "Error during signup.");
      } else {
        setResponseMessage("Unexpected response from the server.");
      }
    } catch (error) {
      // Handle errors properly
      console.error("Error sending OTP:", error.response?.data || error.message);
      setResponseMessage(
        error.response?.data?.msg || "Failed to send OTP. Please try again."
      );
    } finally {
      setLoader(false);
    }
  };

  return (
    <div>
      <Navbar />

      {/* Main Wrapper with Reduced Margin for Higher Placement */}
      <div className="w-full flex flex-col items-center justify-start text-center font-bold bg-bgall h-screen pt-16">
        
        {/* Progress Indicators */}
        <div className="flex space-x-3 mb-6">
          <div className="bg-bgcircle w-[10px] h-[10px] rounded-full"></div>
          <div className="bg-gray-300 w-[10px] h-[10px]"></div>
          <div className="bg-gray-300 w-[10px] h-[10px]"></div>
        </div>

        {/* Heading */}
        <div className="mb-4 text-xl font-semibold text-gray-700">
          {data[lang]["auth"][1]}
        </div>

        {/* Form Container - Moved Up */}
        <div className="bg-white shadow-lg rounded-xl px-6 py-5 sm:w-[90%] md:w-[50%] lg:w-[28%]">
          
          {/* Login Form */}
          <form onSubmit={handleLogin} className="space-y-4">
            
            {/* Mobile Number Input */}
            <div className="text-left">
              <label className="text-[15px] text-gray-700">
                Enter your Mobile Number
              </label>
              <input
                type="text"
                required
                maxLength="10"
                className="w-full px-4 py-2 border rounded-lg bg-bginput my-1 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all text-sm"
                placeholder="Enter 10-digit Mobile Number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg font-medium transition-all text-sm"
            >
              {loader ? (
                <div className="animate-spin h-4 w-4 border-t-2 border-white border-solid mx-auto"></div>
              ) : (
                <span>Proceed</span>
              )}
            </button>
            {responseMessage && (
              <div className="text-green-500 mt-2 text-sm">{responseMessage}</div>
            )}
          </form>

          {/* Signup Link */}
          <div className="mt-4 text-[13px] text-gray-600">
            Don’t have an account?{" "}
            <Link to="/signup" className="text-blue-500 hover:underline">
              Sign Up Here
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;